angular
  .module('app')
  .controller('EditVideoController', EditVideoController);

EditVideoController.$inject = ['Session', 'Upload', '$stateParams', 'Films'];

function EditVideoController(Session, Upload, $stateParams, Films) {
  var vm = this;
  var url = '';
  var id = $stateParams.id;
  var cat = $stateParams.categoria;
  Session.enableLoading();

  var film = Films.get({id: id, cat: cat}).$promise;
  film.then(function (res) {
    Session.disableLoading();
    vm.film = res;
    vm.film.categoria = $stateParams.categoria;
  });

  vm.video = function () {
    if (vm.errorFile) {
      Session.alert('Due to server limitations, the maximum video size is ' + vm.errorFile.$errorParam + '. If we need the video with more quality we will let you know as soon as possible. Sorry for the inconvenience');
    } else {
      url = 'api/v2/film/' + Session.id;
      Session.enableLoading();
      Session.top();
      if (vm.film.video) {
        Upload.mediaDuration(vm.film.video).then(function (duration) {
          vm.film.duration = parseInt(duration, 10);
        });
      } else {
        vm.film.duration = 0;
      }
      Upload.upload({
        resumeChunkSize: '2MB',
        url: url,
        data: {
          film: vm.film.video,
          info: vm.film.titol,
          id: vm.film.id,
          state: 3,
          seccio: vm.film.categoria,
          uid: parseInt(Math.random() * 100000, 10)
        }
      })
      .then(function () {
        Session.reload();
      }, function (resp) {
        console.log('Error status: ' + resp.status);
      }, function (evt) {
        var progress = parseInt(100.0 * evt.loaded / evt.total, 10);
        if (progress < 100) {
          Session.updateProgress(progress);
        } else {
          Session.updateProgress(-1);
        }
      });
    }
  };

  if (!Session.id) {
    Session.go('main.index');
  }
}
